import React from 'react';
import { Button } from '@104ha/base-ui';
import styled from '@emotion/styled';
import { useNavigate } from 'react-router';

type Props = {};

const Wrapper = styled.div`
	padding: 16px;
`;

const NotFound = (props: Props) => {
	const navigate = useNavigate();

	return (
		<Wrapper>
			404 NotFound
			<div>
				<Button.One
					onClick={() => {
						navigate('/');
					}}
				>
					返回
				</Button.One>
			</div>
		</Wrapper>
	);
};

export default NotFound;
